import { z } from 'zod';

// Contrato de la pantalla Marca de agua e impresión (so=400) validado con Zod: un drift
// del backend (so=310 configuración, so=350/400 bitácora) cae al estado de error de la
// query, nunca a un throw en render.

export const PURPOSES = ['interna', 'externa'] as const;
export type Purpose = (typeof PURPOSES)[number];

export const EVENT_TYPES = ['print_view', 'download'] as const;
export type PrintEventType = (typeof EVENT_TYPES)[number];

export const legendSchema = z.object({ key: z.string(), text: z.string(), enabled: z.boolean() });
export type Legend = z.infer<typeof legendSchema>;

export const settingsSchema = z.object({
  legends: z.array(legendSchema),
  opacity: z.number(),
  fontSizePt: z.number(),
  rotationDeg: z.number(),
  colorHex: z.string(),
  tiled: z.boolean(),
  onlyCurrent: z.boolean(),
});
export type WatermarkSettings = z.infer<typeof settingsSchema>;

export const settingsResponseSchema = z.object({
  success: z.literal(true),
  data: settingsSchema,
});

export const printEventSchema = z.object({
  id: z.string(),
  entryId: z.string(),
  eventType: z.enum(EVENT_TYPES),
  purpose: z.string(),
  folio: z.string(),
  documentCode: z.string(),
  documentVersion: z.number().nullable(),
  revisionLabel: z.string().nullable(),
  userId: z.string(),
  userDisplayName: z.string().nullable(),
  /** Nombre de hoy, solo si difiere del grabado al imprimir (QA F1 TIE-05). */
  currentName: z.string().nullable().default(null),
  ip: z.string().nullable(),
  occurredAt: z.string(),
});
export type PrintEvent = z.infer<typeof printEventSchema>;

export const printEventsPageSchema = z.object({
  success: z.literal(true),
  data: z.array(printEventSchema),
  meta: z.object({ next_cursor: z.string().nullable() }),
});

/** Persona del registro (G1-3): quién imprimió o descargó en la empresa activa. */
export const printLogPeopleSchema = z.object({
  success: z.literal(true),
  data: z.array(z.object({ userId: z.string(), displayName: z.string() })),
});
export type PrintLogPerson = z.infer<typeof printLogPeopleSchema>['data'][number];

/** Filtros de la bitácora (estado en la URL). */
export interface PrintLogFilters {
  doc: string | null;
  tipo: PrintEventType | null;
  proposito: Purpose | null;
  desde: string | null;
  hasta: string | null;
  folio: string | null;
  /** Id de la persona que imprimió o descargó (G1-3). */
  persona: string | null;
}
